import { render } from "./UiAuswahlKatalogElement.pug?vue&type=template&id=466c9a91&lang=pug"
import script from "./UiAuswahlKatalogElement.js?vue&type=script&lang=js"
export * from "./UiAuswahlKatalogElement.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__